<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Discovering Marshmallows and Where They Came From"><div class="titlepage"><div><div><h1 class="title"><a id="d0e108" xmlns:saxon="http://icl.com/saxon">Discovering Marshmallows and
        Where They Came From</a></h1></div></div></div><p><a id="d0e108" xmlns:saxon="http://icl.com/saxon">Marshmallows are made from unflavored gelatin, the hot
        sugar syrup that is combined with it, and air that is whipped in. As the gelatin sets, it
        supports the air pockets that have formed within the elastic syrup, providing the structure
        needed to maintain a fluffy texture. </a></p><p><a id="d0e108" xmlns:saxon="http://icl.com/saxon">Marshmallows aren’t a modern invention;
        they’ve been with us in various forms for thousands of years. The ancient Egyptians made
        them by combining honey with the sap from the root of the marsh mallow plant. But unlike
        today, enjoyment of marshmallows back then was limited to Egyptian royalty, and they were
        offered as gifts to the gods. </a></p><p><a id="d0e108" xmlns:saxon="http://icl.com/saxon">In the early nineteenth century, marshmallow
        candy was given to children with sore throats in Western countries, but by the middle of the
        century, the marsh mallow sap was replaced with gelatin, and the candy no longer possessed
        healing powers. </a></p><p><a id="d0e108" xmlns:saxon="http://icl.com/saxon">As the world became more industrialized, extruding machines
        made mass production possible in the middle of the twentieth century, and marshmallows
        became a popular confection throughout the United
        States.</a></p><div class="mediaobject" title="Photo of marshmallows."><a id="d0e108" xmlns:saxon="http://icl.com/saxon"><img alt="Photo of marshmallows." src="images/070405_cube_spoons_0008.jpg"/></a></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?28f167b6